<app-modal
  [open]="open()"
  title="Default Store Print Format"
  [showCancel]="false"
  [showCloseButton]="false"
  [closeOnBackdrop]="false"
  confirmLabel="Save"
  [confirmDisabled]="!canSubmit()"
  (confirmed)="onConfirm()"
>
  @if (open()) {
    <p class="rpf-message">
      Configure a default print format for
      <strong>{{ storeName() }}</strong>
      — it's required before item labels can be printed.
    </p>

    <form [formGroup]="form" class="rpf-form">
      <mat-form-field appearance="outline">
        <mat-label>Print Format</mat-label>
        <mat-select formControlName="printFormatId" required>
          @for (f of labelFormats.formats(); track f.id) {
            <mat-option [value]="f.id">{{ f.name }}</mat-option>
          }
        </mat-select>
        @if (form.controls.printFormatId.touched && form.controls.printFormatId.hasError('required')) {
          <mat-error>A print format is required.</mat-error>
        }
      </mat-form-field>
    </form>
  }
</app-modal>
